<ng-container *ngIf="isModalWindow">
  <sub-header [isModal]="true" [windowHash]="windowHash"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1"
    *ngIf="isModalWindow && isDocsLoaded()">
    <div *ngIf="isModalWindow && isDocsLoaded()">
      <ng-container *ngTemplateOutlet="documentsTemplate"></ng-container>
    </div>
  </p-scrollPanel>
</ng-container>
<div class="wrapper wrapper-content animated fadeInRight" *ngIf="!isModalWindow && isDocsLoaded()">
  <ng-container *ngTemplateOutlet="documentsTemplate"></ng-container>
</div>
<ng-template #documentsTemplate>
  <div class="container-fluid m-t-sm  pb-250">
    <div class="row" *ngIf="isRelatedDocsMode">
      <div class="col-12">
        <dl class="row">
          <dt class="col-12 col-md-4">{{ relatedDoc.entity.division.documentClass.name }}</dt>
          <dd class="col-12 col-md-8"> {{ relatedDoc.entity.division.hierarchicalDescription }}</dd>
          <dt class="col-12 col-md-4">{{ 'General.document' | translate }}</dt>
          <dd class="col-12 col-md-8"> {{ relatedDoc?.name }}</dd>
          <dt class="col-12 col-md-4">{{ 'Documents.state' | translate }}</dt>
          <dd class="col-12 col-md-8"> <span class="p-1  text-truncate font-weight-normal"
              [ngClass]="documentService.getStatusColor(relatedDoc.currentState)"> {{
              relatedDoc?.currentState?.type?.description }} </span>
          </dd>
          <dt class="col-12 col-md-4">{{ 'Documents.creationDate' | translate }}</dt>
          <dd class="col-12 col-md-8"> {{ relatedDoc?.creationDate | date: DATEPIPE_DATETIME_FORMAT }}</dd>
          <dt class="col-12 col-md-4">{{ 'Documents.date' | translate }}</dt>
          <dd class="col-12 col-md-8"> {{ relatedDoc?.modificationDate | date: DATEPIPE_DATETIME_FORMAT }}</dd>
        </dl>
      </div>
    </div>
    <div class="row m-t-sm " *ngIf="isExportMode ()&&!selectedDocsReadOnly">
      <div class="alert alert-info col-12" role="alert">
        <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-5" aria-hidden="true"></i>{{
          'Documents.export.info' | translate }}</span>
      </div>
    </div>
    <!-- FILTROS TEXTUAL -->
    <div class="row  m-t-sm " *ngIf="!isExportMode ()&&!isRelatedDocsMode ">
      <label for="filterText" class="col-12 p-0">{{ 'General.search.maxLength' | translate:{maxLength:
        this.MIN_SEARCH_TEXT_LENGHT} }} <span *ngIf="this.isSearching()" class="m-xs" class="leyenda">
          <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{ 'Filtrando'}} </span></label>
      <div class="col-12 p-0 btn-group">
        <input appDebounceUpKey type="text" class="p-inputtext" placeholder="{{ 'Documents.write.filter' | translate }}"
          name="filterText" id="filterTextInput" [(ngModel)]="filterText" (debounceUpKey)="updateFilter()"
          aria-controls="DataTables_Table_2" autocomplete="off" />
        <button class="btn btn-primary" (click)="load()" type="button" aria-expanded="false"
          title="{{ 'General.reload' | translate}}">
          <i class="fas fa-sync-alt" aria-hidden="true"></i>
          <span class="d-none"> {{ 'General.reload' | translate }}</span>
        </button>
        <!--button class="btn btn-secondary" (click)="clear()" type="button" aria-expanded="false"
          title="{{ 'General.clean' | translate}}">
          <i class="fas fa-undo" aria-hidden="true"></i>
          <span class="d-none"> {{ 'Documents.reset.filters' | translate }}</span>
        </button-->
      </div>
    </div> <!-- FILTROS -->
    <div class="row  filterHeader m-t-sm "
      *ngIf="!isRelatedDocsMode && activeFilters.length > 0 && showFilters ()&&!isExportMode ()">
      <div class="col-12">
        <ng-container *ngFor="let filter of activeFilters">
          <span (click)="removeFilter(filter)" *ngIf="filter.key!='dossierId'&&filter.value!=undefined">
            <a class="btn btn-filter btn-xs m-xs"> {{ filter.label }} <span *ngIf="filter.value !== true">= {{
                filter.value }}</span>
              <i class="fas fa-times ml-1" aria-hidden="true"></i>
            </a>
          </span>
        </ng-container>
      </div>
    </div>
    <!-- AGRUPACION DE DOCUMENTOS -->
    <div class="row m-t-xs" *ngIf="!isExportMode ()&&!isRelatedDocsMode">
      <div class="col-12 p-0 ">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="dropdown d-inline m-l-md">
              <span>{{ 'Documents.folder.sorting' | translate }}: </span>
              <span *ngFor="let group of activeGroups; let num = index" class="d-inline-block m-b-xs">
                <span class="ml-1 mr-1" *ngIf="num!=0"> > </span>
                <a (click)="clearGroup(num)" class="btn btn-filter btn-xs p-1" aria-expanded="false"
                  title="{{ 'General.delete' | translate}}">
                  <span><i class="fa" [ngClass]="groupsBy[group].img" aria-hidden="true"></i> {{
                    groupsBy[group].description }}</span>
                  <i class="fas fa-times ml-1 mr-1" aria-hidden="true"></i>
                </a>
              </span>
              <div class="dropdown  d-inline m-l-md">
                <button class="btn btn-primary" data-toggle="dropdown" type="button" aria-expanded="false"
                  title="{{ 'General.add' | translate}}" [disabled]="!canAddGroup()"
                  pTooltip="{{ this.tooltipMessage }}">
                  <i class="fas fa-plus" aria-hidden="true"></i>
                  <span class="d-none d-md-inline"> {{ 'Documents.add.group' | translate }}</span>
                </button>
                <ul class="dropdown-menu">
                  <li *ngFor="
                      let item of getAgrupaciones(groupsBy[activeGroups.length])
                    " (click)="setAgrupacion(activeGroups.length, item)">
                    <a pTooltip="{{ item.tooltip }}">
                      <i class="fa" [ngClass]="item.img" aria-hidden="true"></i> {{ item.description }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- AGRUPACIONES -->
        </div>
      </div>
    </div>
    <!-- ARBOL DE DOCUMENTOS -->
    <div class="row">
      <div class="col-12 p-0 m-t-sm">
        <p-treeTable [value]="groupedDocuments" selectionMode="checkbox" [resizableColumns]="true"
          (onNodeSelect)="nodeSelect($event)" (onNodeUnselect)="nodeSelect($event)" [(selection)]="selectedNodes"
          (onNodeExpand)="saveNodeStatus($event)" (onNodeCollapse)="saveNodeStatus($event)">
          <ng-template pTemplate="emptymessage">
            <tr>
              <td> {{ 'General.noData' | translate }} </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="caption">
            <!-- CUENTA DE DOCUMENTOS -->
            <div class="row border-bottom" *ngIf="!isExportMode ()&&!isRelatedDocsMode">
              <div class="col-4 d-flex justify-content-start pl-0">
                <span class="leyenda">{{ 'Documents.showing' | translate }} {{ filteredDocuments ?
                  filteredDocuments.length : '0' }} de {{ documents ? documents.length : '0' }}</span>
              </div>
              <div class="col-8 d-flex justify-content-end pr-0">
                <p-tabMenu [model]="items">
                  <ng-template pTemplate="item" let-item let-i="index">
                    <button appNoDblClick type="button" (click)="item.command" class="btn btn-sm btn-outline-secondary"
                      title="{{ item.title | translate }}" showDelay="1000">
                      <i class="{{ item.icon }}" aria-hidden="true"></i><span class="d-none d-sm-inline"> {{ item.label
                        }}</span>
                    </button>
                  </ng-template>
                </p-tabMenu>
              </div>
            </div>
            <ng-container *ngIf="isExportMode ()&&!selectedDocsReadOnly">
              <div>
                <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
                <span class="ml-2">{{'General.selectAll'|translate}}</span>
              </div>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="LONGTEXT text-ellipsis " ttResizableColumn> {{ 'Documents.document.folder' | translate }} </th>
              <th class="CHECK w-50 d-none d-lg-table-cell {{this.orderColum=='VERSION'?'text-primary':''}}"
                ttResizableColumn *ngIf="isRelatedDocsMode"> <a (click)="this.reorder('VERSION')">{{
                  'DocumentView.version' | translate }}</a></th>
              <th class="TEXT d-none d-lg-table-cell w-110 {{this.getClass('STATE')}}" ttResizableColumn
                *ngIf="isRelatedDocsMode || this._colsCodes.includes('STATE')">
                <a (click)="this.reorder('STATE')"> {{ 'Documents.state' | translate }} </a>
              </th>
              <th class="DATE  d-none d-lg-table-cell w-110 {{this.orderColum=='CREATIONDATE'?'text-primary':''}}"
                ttResizableColumn *ngIf="isRelatedDocsMode || this._colsCodes.includes('CREATIONDATE')"> <a
                  (click)="this.reorder('CREATIONDATE')"> {{ 'Documents.creationDate' | translate }} </a></th>
              <th class="DATE  d-none d-lg-table-cell w-110 {{this.orderColum=='DATE'?'text-primary':''}}"
                ttResizableColumn *ngIf="!isRelatedDocsMode&&this._colsCodes.includes('DATE')"> <a
                  (click)="this.reorder('DATE')"> {{ 'Documents.date' | translate }} </a></th>
              <th class="DATE  d-none d-lg-table-cell w-110 {{this.orderColum=='USER'?'text-primary':''}}"
                ttResizableColumn *ngIf="isRelatedDocsMode || this._colsCodes.includes('USER')"> <a
                  (click)="this.reorder('USER')"> {{ 'General.user' | translate }} </a></th>
              <th class="action-column-2x text-right  w-50"> &nbsp; </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-node let-data="rowData">
            <tr [ttRow]="node" class="col-12">
              <!--
                sortField
              -->
              <td class="">
                <p-treeTableToggler [rowNode]="node"></p-treeTableToggler>
                <ng-container *ngIf="isExportMode ()">
                  <!-- [disabled]="true" -->
                  <p-treeTableCheckbox [value]="node" [disabled]="selectedDocsReadOnly"></p-treeTableCheckbox>
                </ng-container>
                <!-- descripcion de agrupacion -->
                <span *ngIf="node.children && data.group" class="leyenda"><i class="fa fa-1-5x"
                    [ngClass]="data.group.img"></i> {{ data.name }}</span>
                <span *ngIf="!data.document" class="leyenda"><i class="fa fa-1-5x" [ngClass]="data.group.img"></i> {{
                  data.name }}</span>
                <!-- descripcion de documento -->
                <span *ngIf="data.document" class="doc-name text-break" (mouseenter)="docTooltip.toggle($event)"
                  (mouseleave)="docTooltip.toggle($event)"> <i
                    class=" {{data.document?.multidocument==true?'fa fa-files-o':'far fa-file-alt'}} px-1 fa-1-5x {{data.document?.type=='Original'?'text-info':data.document?.type=='Draft'?'text-secondary':data.document?.type=='CertifiedCopy'?'text-success':''}}"
                    aria-hidden="true"></i>
                  <a *ngIf="!this.isModalWindow" [routerLink]="['/documentViewer', data.document.identifier]">{{
                    data.document.name }}</a>
                  <a *ngIf="this.isModalWindow" (click)="openDocument (data.document)">{{ data.document.name }}</a>
                  <img *ngIf="dossier && data.document.locale  && data.document.locale !== dossier.locale"
                    style="vertical-align: middle; padding-left: 5px;" src="assets/img/{{data.document.locale}}.gif"
                    height="15px" pTooltip="{{('Languages.' + data.document.locale) | translate}}" />
                </span>
                <p-overlayPanel #docTooltip appendTo="body" [showTransitionOptions]="'1000ms'"
                  [hideTransitionOptions]="'500ms'" [style]="{'max-width': '45vw'}">
                  <div class="row">
                    <span class="col-12 font-bold ">{{ data.document?.name }}</span>
                    <span class="col-12"> <i
                        class=" {{data.document?.multidocument==true?'fa fa-files-o':'far fa-file-alt'}}  px-1 fa-1-5x {{data.document?.type=='Original'?'text-info':data.document?.type=='Draft'?'text-secondary':data.document?.type=='CertifiedCopy'?'text-success':''}}"
                        aria-hidden="true"></i> {{('Documents.types.'+data.document?.type) | translate}} </span>
                    <span class="col-12 " *ngIf="data.document?.user"> <i class="fas fa-user" aria-hidden="true"></i>
                      <span> [{{data.document?.user?.identifier}}]</span>
                    </span>
                    <span class="col-12" *ngIf="data.document?.currentState?.type?.description"> <span
                        class="font-bold ">{{'Documents.state' | translate}}:</span>
                      {{data.document?.currentState?.type?.description }}</span>
                    <span class="col-12 " *ngIf="data.document?.entity?.division?.identifier"> <span
                        class="font-bold ">{{'General.division' | translate}}:</span> #{{ _getSimpleIdentifierFromString
                      (data.document?.entity?.division?.identifier) }} {{
                      data.document?.entity?.division?.hierarchicalDescription }}</span>
                    <span class="col-12 " *ngIf="data.document?.thirdParty"> <span
                        class="font-bold ">{{'General.thirdParty' | translate}}:</span>
                      {{data.document.thirdParty.taxIdentifier + ' - ' + data.document.thirdParty.name }}</span>
                    <span class="col-12"> <span class="font-bold ">{{'General.type' | translate}}:</span> {{
                      data.document?.entity?.documentClass?.name }}</span>
                    <span class="col-12" *ngIf="data.document?.markedAsCompleted"> {{'Documents.completed'|translate}}
                    </span>
                  </div>
                </p-overlayPanel>
                <span *ngIf="!data.document" class=" leyenda">{{ data.groupname }}</span>
              </td>
              <td class="CHECK w-50 d-none d-lg-table-cell" *ngIf="isRelatedDocsMode">
                <span *ngIf="data?.document?.currentVersion?.versionNumber"> {{
                  data.document.currentVersion.versionNumber }}</span>
              </td>
              <td class="TEXT d-none d-lg-table-cell  w-110"
                *ngIf="isRelatedDocsMode||this._colsCodes.includes('STATE')">
                <span class="p-1 w-100 text-truncate font-weight-normal"
                  [ngClass]="documentService.getStatusColor(data.document.currentState)" *ngIf="
                    data.document &&
                    data.document.currentState &&
                    data.document.currentState.type
                  "> {{ data.document.currentState.type.description }} </span>
              </td>
              <td class="DATE d-none d-lg-table-cell  w-110" *ngIf=" isRelatedDocsMode ||
                this._colsCodes.includes('CREATIONDATE')">
                <span *ngIf="data.document"> {{ data.document.creationDate | date: DATEPIPE_DATETIME_FORMAT }}</span>
              </td>
              <td class="DATE d-none d-lg-table-cell  w-110"
                *ngIf="!isRelatedDocsMode&&this._colsCodes.includes('DATE')">
                <span *ngIf="data.document"> {{ data.document.modificationDate | date: DATEPIPE_DATETIME_FORMAT
                  }}</span>
              </td>
              <td class="TEXT d-none d-lg-table-cell  w-110"
                *ngIf="isRelatedDocsMode||this._colsCodes.includes('USER')">
                <user [user]="data.document.user" *ngIf="data?.document?.user?.identifier"></user>
              </td>
              <td class="action-column-2x text-right  w-50">
                <pmenu-actions [dto]="data.document" (reload)="this.load()" [lazy]="true" [dtoType]="'DOCUMENT'"
                  [items]="getDocMenuItem(data.document)"
                  [postProcessMenuActionsFn]="updateCorrectDocumentAction.bind(this)"
                  *ngIf="!isExportMode()&&!isRelatedDocsMode&&!isModalWindow && data.document">
                </pmenu-actions>
                <pmenu-actions [dto]="data.document" (reload)="this.load()" [lazy]="false" [dtoType]="'DOCUMENT'"
                  [items]="getRelatedDocsMenuItem(data.document)"
                  [postProcessMenuActionsFn]="updateCorrectDocumentAction.bind(this)"
                  *ngIf="(isRelatedDocsMode||isExportMode()) && data.document">
                </pmenu-actions>
                <div class="btn-group" *ngIf="!isModalWindow && data.document">
                </div>
                <button type="button" class="btn  btn-primary btn-sm t-action-button"
                  title="{{ 'General.select' | translate}}" (click)="selectDocument(data.document)"
                  *ngIf="isModalWindow && data.document && isSingleSelection ()">
                  <i class="fas fa-check" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </div>
</ng-template>
<!--
    *************************************************************************************************
    ZONA DE FILTROS AVANZADOS (MODAL)
    *************************************************************************************************
  -->
<p-dialog header="{{ 'General.filters' | translate }}" [(visible)]="filtersVisible" [responsive]="true"
  (onHide)="onCloseFilters()" [modal]="true" [resizable]="false" [closable]="true" [closeOnEscape]="false"
  [blockScroll]="true" [style]="{'width':'60vw'}" [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}"
  styleClass='searchStyle'>
  <sub-header [isModal]="true" [windowHash]=this.filterWindowHash [includeContextHelp]="false" *ngIf="filtersVisible">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid pb-5">
      <div class="row">
        <div class="col-12">
          <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
          </formPlyca>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>
<p-dialog header="{{ 'DossiersView.config.title' | translate }}" [(visible)]="selectColumnsVisible"
  (onHide)="onCloseColumnSelector()" [responsive]="true" [modal]="true" [resizable]="false" [closable]="true"
  [dismissableMask]="true" [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'50vw'}"
  [contentStyle]="{ 'min-height': '50vh', 'max-height': '50vh', overflow: 'hidden'}" cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true" styleClass='searchStyle column-selector' [draggable]="false">
  <sub-header [isModal]="true" [windowHash]=this.colsSelectorWindowHash [includeContextHelp]="false"
    *ngIf="selectColumnsVisible">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row ">
        <ng-container>
          <h3 class="leyenda col-12 text-center m-t-md">{{'DossiersView.colsActivas'|translate}}:</h3>
          <div class="col-12 d-flex justify-content-center m-b-lg">
            <p-listbox [options]="allColumns" [(ngModel)]="visibleColumns" optionLabel="name" [multiple]="true"
              [checkbox]="true" [ngClass]="'col-10'" [showToggleAll]="false">
            </p-listbox>
          </div>
        </ng-container>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>